import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  filterList: {
    marginBottom: pxToRem(16),
  },
  filter: {
    borderBottom: `solid 1px ${theme.palette.neutralLight}`,
    paddingTop: pxToRem(8),
    paddingBottom: pxToRem(8),
  },
  downButton: {
    marginRight: pxToRem(14),
    background: `${theme.palette.neutralWhite} !important`,
  },
  calcType: {
    fontWeight: 400,
  },
  upButton: {
    background: `${theme.palette.neutralWhite} !important`,
  },
});
